import { axiosClient } from "./apiClient";

export function signup(data) {
  return axiosClient.post("auth/signup", data);
}
export function signupByFace(data) {
  return axiosClient.post("/auth/signup-by-face", data);
}

export function login(data) {
  console.log("data-->", data);
  return axiosClient.post("auth/login", data);
}
export function faceLogin(data) {
  console.log("data-->", data);
  return axiosClient.post("/auth/login-by-face", data);
}

export function forgotPassword(data) {
  return axiosClient.post("auth/forgot-password", data);
}
export function logout(data) {
  return axiosClient.get("auth/logout", data);
}
export function getProfile(data) {
  return axiosClient.get("auth/get-profile", data);
}
export function editProfile(data) {
  return axiosClient.post("auth/update-profile", data);
}
export function getCountryList(data) {
  return axiosClient.get("auth/get-countries", data);
}
export function changePassword(data) {
  return axiosClient.post("auth/change-password", data);
}
export function home(data) {
  return axiosClient.post("auth/home", data);
}
export function verifyToken(data) {
  return axiosClient.get("auth/verify-token", data);
}
export function getDoctor(data) {
  return axiosClient.post("patient/doctors-list", data);
}
export function getUserList(data) {
  // return axiosClient.post("patient/user-list", data);
  return axiosClient.post("gpt/search-all-users", data);
}
export function searchChatGpt(data) {
  return axiosClient.post("gpt/gpt-get-response", data);
}
export function createChatCompletion(data) {
  return axiosClient.post("gpt/poc-create-chat-completion", data);
}

export function starpilotSingleChatStore(data) {
  return axiosClient.post("gpt/starpilot-single-chats-store", data);
}

export function starpilotSingleMicChatStore(data) {
  return axiosClient.post("gpt/starpilot-single-mic-chats-store", data);
}

export function starpilotSingleChatStoreResponse(data) {
  return axiosClient.post("gpt/starpilot-single-chats-response", data);
}
export function starpilotSingleChatStoreTextReply(data) {
  return axiosClient.post("gpt/starpilot-single-chats-text-reply", data);
}

export function starpilotSingleMicChatStoreResponse(data) {
  return axiosClient.post("gpt/starpilot-single-chats-mic-response", data);
}
export function starpilotSingleMicChatStoreTextReply(data) {
  return axiosClient.post("gpt/starpilot-single-chats-mic-text-reply", data);
}

export function createMonteChatBotCompletion(data) {
  return axiosClient.post("gpt/poc-create-monte-chatbot-completion", data);
}
export function createChatAnalysisCompletion(data) {
  return axiosClient.post(
    "gpt/poc-create-chat-completion-prescription-analysis",
    data
  );
}

export function createChatXrayMriAnalysisCompletion(data) {
  return axiosClient.post(
    "gpt/poc-create-chat-completion-prescription-xray-mri-analysis",
    data
  );
}
export function editPocChatRoom(data) {
  return axiosClient.post("gpt/edit-poc-chat-room", data);
}
export function GetPocChatSideList(data) {
  return axiosClient.post("gpt/get-poc-chat-history-list", data);
}
export function GetPocChatHistor(data) {
  return axiosClient.post("gpt/get-poc-chat-history", data);
}
export function createTextToSpeechCompletion(data) {
  return axiosClient.post("gpt/text-to-speech-completion", data);
}
export function createChatPrescCompletion(data) {
  return axiosClient.post("gpt/poc-create-chat-completion-prescription", data);
}

export function getChatPrescCompletion(data) {
  return axiosClient.post(
    "gpt/view-send-poc-create-chat-completion-prescription",
    data
  );
}

export function createPrescChatCompletionForStarpilot(data) {
  return axiosClient.post(
    "gpt/starpilot-create-chat-completion-prescription",
    data
  );
}

export function sendPrescription(data) {
  return axiosClient.post(
    "gpt/send-poc-create-chat-completion-prescription",
    data
  );
}
export function sendAutoPrescription(data) {
  return axiosClient.post("gpt/send-prescription-to-others-from-email", data);
}

export function createChatCompletionForDocsumo(data) {
  return axiosClient.post("gpt/docsumo-create-chat-completion", data);
}

export function getManagePage(data) {
  return axiosClient.post("auth/get-page-content", data);
}
export function patientfeedback(data) {
  return axiosClient.post("feedback/send-patient", data);
}
export function userSupport(data) {
  return axiosClient.post("feedback/user-query", data);
}
export function getfeedback(data) {
  return axiosClient.post("feedback/get-feedback", data);
}
export function getfeedbackList(data) {
  return axiosClient.post("feedback/get-feedback-list", data);
}
export function verifyEmail(data) {
  return axiosClient.post("auth/verify-email", data);
}

export function doctorAppointment(data) {
  return axiosClient.post("patient/doctors-list", data);
}

export function doctorAppointmentListAvailable(data) {
  return axiosClient.post("patient/doctors-list-appointment", data);
}

export function storeDataSitepal(data) {
  return axiosClient.post("isabel/ranked-differential-diagnoses-sc", data);
}
export function storeDoctorDataSitepal(data) {
  return axiosClient.post("isabel/ranked-differential-diagnoses-pro", data);
}

export function getDoctorSpecialities(data) {
  return axiosClient.get("auth/get-doctors-specialties", data);
}
export function editDoctorProfile(data) {
  return axiosClient.post("auth/update-doctor-profile", data);
}
export function updateDoctorOnlineStatus(data) {
  return axiosClient.post("auth/update-doctor-online-status", data);
}

export function updateDoctorAppointmnetStatus(data) {
  return axiosClient.post("auth/update-doctor-available-status", data);
}

export function getDoctorProfile(data) {
  return axiosClient.get("auth/get-doctor-profile", data);
}

export function doctorfeedback(data) {
  return axiosClient.post("feedback/send-doctor", data);
}
export function prescription(data) {
  return axiosClient.post("doctor/add-prescription", data);
}
export function singleUserAddPrescription(data) {
  return axiosClient.post("gpt/single-user-add-prescription", data);
}

export function uploadMedicalRecord(data) {
  return axiosClient.post("docsumo/store-docsumo-data", data);
}

export function getReportDetails(data) {
  return axiosClient.post("isabel/get-generated-reports", data);
}
export function getIsabelCountryList(data) {
  return axiosClient.get("isabel/get-countries-sc", data);
}

export function patientAppointmentRequests(data) {
  return axiosClient.post("doctor/patient-appointment-requests", data);
}
export function patientMeetingStatus(data) {
  return axiosClient.post("doctor/patient-meetings-status", data);
}
export function doctorSingleMicMeetingStatus(data) {
  return axiosClient.post("doctor/single-mic-meetings-histories", data);
}
export function doctorSingleUserMeetingStatus(data) {
  return axiosClient.post("gpt/get-starpilot-single-user-history", data);
}
export function getMeetingUsers(data) {
  return axiosClient.post("gpt/get-meeting-users", data);
}

export function doctorSingleMicMeetingDetails(data) {
  return axiosClient.post("doctor/get-starpilot-single-mic-chat-history", data);
}
export function doctorSingleUserMeetingDetails(data) {
  return axiosClient.post("gpt/get-sp-single-user-meeting-records", data);
}

export function sendMeetingDetail(data) {
  return axiosClient.post("doctor/mail-meeting-record", data);
}
export function sendMeetingDetailUserMail(data) {
  return axiosClient.post("gpt/mail-sp-meeting-records", data);
}

export function getFinalPostralSummary(data) {
  return axiosClient.post("/gpt/get-final-pastoral-summary", data);
}

//patient-waiting
export function patientWaitingStatus(data) {
  return axiosClient.post("doctor/patient-waiting", data);
}
export function patientMeetingStatusOngoing(data) {
  return axiosClient.post("doctor/patient-meetings-status_ongoing", data);
}
export function updateAppoinmentStatus(data) {
  return axiosClient.post("doctor/update-appointment-status", data);
}

export function updateAppoinment(data) {
  return axiosClient.post("patient/update-appointment", data);
}

export function cancelAllPatientAppoinment(data) {
  return axiosClient.post("patient/end-all-meetings", data);
}

export function checkUpdateAppoinmentStatus(data) {
  return axiosClient.post("patient/check-appointment-status-list", data);
}
export function checkAppointmentStatusOngoing(data) {
  return axiosClient.post("patient/check-appointment-status-ongoing", data);
}
export function myAppoinments(data) {
  return axiosClient.post("patient/my-appointments", data);
}

export function getMyAppoinments(data) {
  return axiosClient.post("doctor/my-appointments", data);
}

export function cancleAppoinments(data) {
  return axiosClient.post("patient/cancel-appointment", data);
}

export function canclePatientAppoinments(data) {
  return axiosClient.post("doctor/cancel-appointment", data);
}

export function generateCodes(data) {
  return axiosClient.get("patient/generate-permission-codes", data);
}
export function permissionCodeRequestDoctorList(data) {
  return axiosClient.post("patient/permission-code-doctors-request-list", data);
}
export function sendPermissionCode(data) {
  return axiosClient.post("patient/send-permission-codes", data);
}

export function connectedPatientList(data) {
  return axiosClient.post("doctor/connected-patient-list", data);
}
export function sendPermissionCodeRequest(data) {
  return axiosClient.post("doctor/send-permission-codes-request", data);
}

export function checkPermissionCodeAccessbility(data) {
  return axiosClient.post("patient/check-permission-code-accessibility", data);
}

export function setDoctorAvailability(data) {
  return axiosClient.post("doctor/set-availability", data);
}
export function getDoctorAvailability(data) {
  return axiosClient.get("doctor/get-availability", data);
}

export function doctorMeeting(data) {
  return axiosClient.post("meeting/start-aws-chime-meeting", data);
}

export function inviteUsersListMeeting(data) {
  return axiosClient.post("meeting/usersList", data);
}
export function joinOtherUserApi(data) {
  return axiosClient.post("meeting/create-attendee", data);
}
export function pastoralSummary(data) {
  return axiosClient.post("/gpt/starpilot-create-chat-pastoral-summary", data);
}
export function findPastoralSummaryFromChime(data) {
  return axiosClient.post("doctor/find-pastrol-summary-from-chime", data);
}

export function pastoralSummaryPdf(data) {
  return axiosClient.post("gpt/get-pastoral-summary-pdf", data);
}

export function meetingInfoApi(data) {
  return axiosClient.post("meeting/meeting_detail", data);
}

export function sendMeetingInvite(data) {
  return axiosClient.post("meeting/sendInvite", data);
}

export function getDownloadChimeConversationGptResponseTextFile(data) {
  return axiosClient.post(
    "meeting/get-download-chime-conversation-gpt-response-text-file",
    data
  );
}
export function getStarPilotMonteTextReply(data) {
  return axiosClient.post("doctor/get-starpilot-monte-chat-text-reply", data);
}
export function getStarPilotMonteTextReplyTrsln(data) {
  return axiosClient.post(
    "doctor/get-starpilot-monte-chat-text-reply-trsln",
    data
  );
}

export function getStarPilotMonteChatHistory(data) {
  return axiosClient.post("doctor/get-starpilot-monte-chat-history", data);
}

export function getStarPilotMonteChatHistoryTrsln(data) {
  return axiosClient.post(
    "doctor/get-starpilot-monte-chat-history-trsln",
    data
  );
}

export function getPrescriptionHistory(data) {
  return axiosClient.post("doctor/get-prescription-history", data);
}
export function getQrPrescription(data) {
  return axiosClient.post("meeting/qr_prescription", data);
}

//get-prescription-history
export function getSuggestionBoxChatHistory(data) {
  return axiosClient.post("doctor/get-suggestion-box-chat-history", data);
}

export function getStarPilotMonteChat(data) {
  return axiosClient.post("doctor/get-starpilot-monte-chat", data);
}

export function getStarPilotMonteChatTrsln(data) {
  return axiosClient.post("doctor/get-starpilot-monte-chat-trsln", data);
}
export function getStarPilotMonteChatTrslnSingleMic(data) {
  return axiosClient.post("doctor/get-starpilot-single-mic-chat-trsln", data);
}

export function getStarPilotMonteChatTrslnO1Mini(data) {
  return axiosClient.post(
    "doctor/get-starpilot-monte-chat-trsln-o1-mini",
    data
  );
}

export function getStarPilotMonteChatTrslnO3Mini(data) {
  return axiosClient.post(
    "doctor/get-starpilot-monte-chat-trsln-o3-mini",
    data
  );
}

export function getStarPilotMonteChatMini(data) {
  return axiosClient.post("doctor/get-starpilot-monte-chat-mini", data);
}

export function getStarPilotMonteChatO3Mini(data) {
  return axiosClient.post("doctor/get-starpilot-monte-chat-03-mini", data);
}

export function getStarPilotMonteChatGemini(data) {
  return axiosClient.post("doctor/get-starpilot-monte-chat-gemini", data);
}
export function getAwsChimeChatGptResponse(data) {
  return axiosClient.post("doctor/get-aws-chime-chat-gpt-response", data);
}
export function getAwsChimeChatGptMessages(data) {
  return axiosClient.post("doctor/get-aws-chime-chat-gpt-messages", data);
}

export function findPrescriptionListFromChimeConversation(data) {
  return axiosClient.post(
    "doctor/find-prescription-list-from-chime-conversation",
    data
  );
}

export function meetingEndPrescriptionListFromChimeConversation(data) {
  return axiosClient.post(
    "doctor/meet-end-prescription-list-from-chime-conversation",
    data
  );
}

export function isRxSentForAutoFillPrescription(data) {
  return axiosClient.post("doctor/is-rx-sent-for-autofill-prescription", data);
}
export function storeChimePrompt(data) {
  return axiosClient.post("doctor/store-chime-prompt", data);
}
export function addChimePromptInConversation(data) {
  return axiosClient.post("doctor/add-chime-prompt-in-conversation", data);
}
export function addChimePromptInConversationSingleMic(data) {
  return axiosClient.post(
    "doctor/add-chime-prompt-in-single-mic-conversation",
    data
  );
}
export function PatientList(data) {
  return axiosClient.post("doctor/search-patients", data);
}
export function getTranscriptConversation(data) {
  return axiosClient.post("doctor/get-transcript-in-conversation", data);
}
export function addTranscriptLanguage(data) {
  return axiosClient.post(
    "doctor/add-transcript-language-in-conversation",
    data
  );
}

export function addTextInTranscript(data) {
  return axiosClient.post("doctor/add-txt-in-transcript", data);
}

export function allChemistList(data) {
  return axiosClient.get("doctor/chemist-list", data);
}
export function prescriptionSendRx(data) {
  return axiosClient.post("doctor/prescription-send-rx", data);
}

export function getPatientReportShareMedical(data) {
  return axiosClient.post("doctor/get-patient-report-share-medical", data);
}
export function getPatientReport(data) {
  return axiosClient.post("patient/get-patient-report-share-medical", data);
}

export function getPatientReportAnalysis(data) {
  return axiosClient.post("patient/get-patient-report-analysis", data);
}

export function makeAppoinment(data) {
  return axiosClient.post("patient/make-appointment", data);
}
export function drAppointment(data) {
  return axiosClient.post("doctor/make-single-mic-appointment", data);
}
export function checkPermissionCode(data) {
  return axiosClient.post("doctor/check-permission-code-expiration", data);
}

export function patientInformation(data) {
  return axiosClient.post("doctor/patient-information", data);
}
export function addPrescriptionMedicine(data) {
  return axiosClient.post("doctor/add-prescription-medicines", data);
}
export function getMedicineList(data) {
  return axiosClient.post("doctor/get-prescription-medicines", data);
}
export function getMedicineDetailsById(data) {
  return axiosClient.post(
    "doctor/get-prescription-medicine-details-by-id",
    data
  );
}
export function updatePrescriptionMedicine(data) {
  return axiosClient.post("doctor/update-prescription-medicine", data);
}
export function updateSafetyQcChecked(data) {
  return axiosClient.post(
    "doctor/update-safety-qc-checked-for-prescription",
    data
  );
}

export function createPrescriptionXray_Mri(data) {
  return axiosClient.post(
    "poc-create-chat-completion-prescription-xray-mri-analysis",
    data
  );
}

export function removePrescriptionMedicine(data) {
  return axiosClient.post("doctor/delete-prescription-medicine", data);
}

export function getPatientDocsumoRecordList(data) {
  return axiosClient.post("doctor/get-patient-docsumo-record-list", data);
}
export function extractData(data) {
  return axiosClient.post("docsumo/extract-data", data);
}
export function getDownloadPatientReportExtractDataTextFile(data) {
  return axiosClient.post(
    "docsumo/get-download-patient-report-extract-data-text-file",
    data
  );
}
export function getPatientOwnDocsumoRecordList(data) {
  return axiosClient.post("patient/get-patient-own-docsumo-record-list", data);
}

export function sendContactUsMessage(data) {
  return axiosClient.post("auth/contactus", data);
}

export function getChatRoomList(data) {
  return axiosClient.post("chat/chat-room-list", data);
}

export function getChatPrayerRoom(data) {
  return axiosClient.post("chat/user-prayer-rooms", data);
}

export function CreateChatGroup(data) {
  return axiosClient.post("chat/add-chat-room", data);
}
export function JoinPatientToGroup(data) {
  return axiosClient.post("/chat/join-chat-room", data);
}
export function prayerRoomGroupList(data) {
  return axiosClient.post("chat/prayer-rooms", data);
}

export function invitePatientToGroup(data) {
  return axiosClient.post("/chat/invite-users", data);
}

export function acceptDeclineChat(data) {
  return axiosClient.put("/chat/update-invite", data);
}

export function editChatGroup(data) {
  return axiosClient.put("chat/edit-chat-room", data);
}

export function getRoomCategoryList(data) {
  return axiosClient.post("chat/chat-catg", data);
}

export function getRoomMessageList(data) {
  return axiosClient.post("chat/chat-msges", data);
}
export function getRoomGroupMembers(data) {
  return axiosClient.post("/chat/group-members", data);
}
export function deleteGroupMember(data) {
  return axiosClient.post("/chat/patient-remove", data);
}

export function checkRoom(data) {
  return axiosClient.post("/chat/check-chat-room", data);
}

export function enrollPatientByFace(data) {
  return axiosClient.post("/auth/face-enroll", data);
}

export function detectPatientByFace(data) {
  return axiosClient.post("doctor/search-patients-by-face", data);
}

export function genereateQRCode(data) {
  return axiosClient.post("/gpt/get-medicines-qr-codes", data);
}
export function startLiveStreming(data) {
  return axiosClient.post("/meeting/start-live-streaming", data);
}
export function updateLiveStreming(data) {
  return axiosClient.put("/meeting/update-live-streaming", data);
}
